import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared';
import { UsuarioSharedModule } from '../../home/usuario';

import { AccountMenuComponent } from '../../domains/shared/components/account-menu/account-menu.component';
import { NotificationMenuModule } from '../notification-menu/notification-menu.module';
import { HeaderComponent } from './header.component';

@NgModule({
    imports: [
        RouterModule,
        SharedModule,
        UsuarioSharedModule,
        NotificationMenuModule
    ],
    declarations: [
        HeaderComponent,
        AccountMenuComponent,
    ],
    exports: [
        HeaderComponent
    ]
})
export class HeaderModule { }
